module.exports = __webpack_public_path__ + "static/media/th-face-bg.3645870b.svg";